import TransactionModalsDepositContentTransactionForm from './Form';
import DepositResponse from './Response';
import { DepositStep } from '@starsoft/common/enums';
import { TransactionsModalDepositContentFormLayoutProps } from './props';
import useDepositSearchParams from '../../../../../hooks/deposit/useDepositSearchParams';
import UserIdentityForm from '../../../../KYC/UserIdentity/Form';

/**
 * TransactionModalsDepositContent Component
 * This component is responsible for rendering different content based on the current deposit step.
 * It utilizes the `useDepositSearchParams` hook to determine the current step and renders the appropriate component.
 *
 * @param {TransactionsModalDepositContentFormLayoutProps} props - The properties for the component.
 * @param {React.ReactNode} props.additionalContent - Additional content to be rendered inside the deposit form.
 *
 * @returns {JSX.Element} The rendered component based on the current deposit step.
 *
 * @example
 * // Usage example:
 * <TransactionModalsDepositContent additionalContent={<div>Extra Content</div>} />
 */
export default function TransactionModalsDepositContent({
  additionalContent,
}: TransactionsModalDepositContentFormLayoutProps) {
  // Retrieve the current transaction step from the deposit search parameters
  const { transactionStep } = useDepositSearchParams();

  // Render different components based on the current transaction step
  switch (transactionStep) {
    case DepositStep.Form:
      // Render the deposit form with additional content
      return (
        <TransactionModalsDepositContentTransactionForm
          additionalContent={additionalContent}
        />
      );
    case DepositStep.CreatePersonalIdentity:
      // Render the user identity form for KYC
      return <UserIdentityForm usePartialForm isContainerColor />;
    case DepositStep.Response:
      // Render the deposit response component
      return <DepositResponse />;
  }
}
